import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

/** CSS Files */
import "./ProjectStatusTable.scss";

/** Common Services & Data Files */
import Iconify from "../../../../../layouts/components/iconify/iconify";
import ToastService from "../../../../../services/toastService/ToastService";

/** RTK Query */
import { useUpdateOrderProjectStatusConfigurationMutation } from "../../../../../app/services/projectStatusAPI";

const ProjectStatusTable = ({ initialData, onDeleteClick, onEditAction }) => {
  /* State*/
  const [data, setData] = useState(initialData);

  // API'S Call
  const [updateOrderProjectStatusConfiguration, {
    isSuccess: isSuccessupdateOrderProjectStatusConfiguration, 
    data: updateOrderProjectStatusConfigurationData
  }] = useUpdateOrderProjectStatusConfigurationMutation();

  //** useEffect's */
  useEffect(() => {
    const sortedInitialData = [...initialData].sort((a, b) => a.orderId - b.orderId);
    setData(sortedInitialData)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData || onDeleteClick, onEditAction])

  useEffect(() => {
    if (isSuccessupdateOrderProjectStatusConfiguration && updateOrderProjectStatusConfigurationData) {
      if (updateOrderProjectStatusConfigurationData.errorMessage.includes("exists")) {
        ToastService.warning(updateOrderProjectStatusConfigurationData.errorMessage);
        return;
      } else {
        ToastService.success(updateOrderProjectStatusConfigurationData.errorMessage);
      }
    }
  }, [isSuccessupdateOrderProjectStatusConfiguration, updateOrderProjectStatusConfigurationData])
  
  //** Funcation's */
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedData = [...data];
    const [movedRow] = reorderedData.splice(result.source.index, 1);
    reorderedData.splice(result.destination.index, 0, movedRow);

    const updatedDataOnlyIds = reorderedData.map((item, index) => ({
      orderId: index + 1,
      projectStatusConfigurationId: item.projectStatusConfigurationId
    }));

    const updatedData = reorderedData.map((item, index) => ({
      ...item,
      orderId: index + 1,
    }));
    const sortedData = updatedData.sort((a, b) => a.orderId - b.orderId);
    setData(sortedData);

    updateOrderProjectStatusConfiguration({ orderProjectStatusConfigurationList: updatedDataOnlyIds });
  };


  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <DragDropContext onDragEnd={handleDragEnd}>
        <table
          className="status-table"
          style={{
            borderCollapse: "collapse",
            width: "100%",
            border: "1px solid #ddd",
          }}
        >
          <thead>
            <tr>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Order
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Status Name
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                {/* Status */}
                Current Status
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                {/* Complete */}
                Completion Status
              </th>
              <th style={{ padding: "10px", border: "1px solid #ddd" }}>
                Action
              </th>
            </tr>
          </thead>
          <Droppable droppableId="table-body">
            {(provided) => (
              <tbody
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{ background: "#f9f9f9" }}
              >
                {data.map((row, index) => (
                  <Draggable key={row.orderId} draggableId={row.orderId.toString()} index={index}>
                    {(provided, snapshot) => (
                      <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={`draggable-row ${snapshot.isDragging ? "dragging" : ""
                          }`}
                        style={{
                          ...provided.draggableProps.style,
                          background: snapshot.isDragging ? "" : "#fff", // Optional: Dragging row background
                          borderBottom: "1px solid #ddd",
                          width: snapshot.isDragging
                            ? `${provided.innerRef.current?.clientWidth}px`
                            : "",
                          boxSizing: "", // Ensure padding and borders are considered
                          ...(!snapshot.isDragging && {
                            transition: "all 0.2s ease",
                          }),
                        }}
                      >
                        <td>
                          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                            <div className="drag-button">
                              <Iconify
                                icon="akar-icons:drag-vertical"
                                width={12}
                              />
                            </div>
                            {row.orderId}
                          </div>
                        </td>
                        <td
                        >
                          {row.statusName}
                        </td>
                        <td
                        >
                          <span className={row.isActive ? "active" : "inactive"}>
                            {row.isActive ? "Active" : "inActive"}
                          </span>
                        </td>
                        <td
                          style={{ padding: "10px", border: "1px solid #ddd" }}
                        >
                          <span className={row.isComplete ? "complete" : "incomplete"}>
                            {row.isComplete ? "Complete" : "Incomplete"}
                          </span>
                        </td>
                        <td
                          style={{
                            border: "1px solid #ddd",
                            textAlign: "center",
                          }}
                        >
                          <div className="action-buttons">
                            <button
                              className="task-icon"
                              onClick={() => onEditAction(row)}
                              aria-label="Edit task"
                            >
                              <Iconify icon="line-md:pencil" />
                            </button>
                            <button
                              className="delete-icon"
                              onClick={() => onDeleteClick(row)}
                              aria-label="Delete task"
                            >
                              <Iconify icon="mingcute:delete-2-line" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </tbody>
            )}
          </Droppable>
        </table>
      </DragDropContext>
    </div>
  );
};

export default ProjectStatusTable;
